<script>
	import { LayerCake, Svg, Html, groupLonger, flatten } from "layercake";

	import { scaleOrdinal } from "d3-scale";

	import MultiLine from "./components/MultiLine.svelte";
	import AxisX from "../common/AxisX.svelte";
	import AxisY from "../common/AxisY.svelte";
	import Labels from "./components/GroupLabels.svelte";

	export let yTicks;
	export let add2021;
	export let showSeriesLabels = true;
	export let data;
	export let seriesColors = ["#ffe4b8", "#ffb3c0", "#ff7ac7", "#ff00cc"];
	export let label;
	export let formatTickY = (value) => value;
	export let formatTickX = (value) => value.getFullYear();
	export let formatValueLabel = (value) => value;
	export let xTickPosition = "top";
	export let yTickMarks = true;
	export let yGridlines = false;
	export let xGridlines = true;
	export let paddingLeft = 0;
	export let yMax = null;
	export let labelPosition;

	/* --------------------------------------------
	 * Set what is our x key to separate it from the other series
	 */
	const xKey = "year";
	const yKey = "value";
	const zKey = "group";

	const seriesNames = Object.keys(data[0]).filter((d) => d !== xKey);

	/* --------------------------------------------
	 * Cast values
	 */
	data.forEach((d) => {
		d[xKey] = typeof d[xKey] === "string" ? new Date(d[xKey], 0, 1) : d[xKey];

		seriesNames.forEach((name) => {
			d[name] = +d[name];
		});
	});

	const groupedData = groupLonger(data, seriesNames, {
		groupTo: zKey,
		valueTo: yKey,
	});

	let xTicks = data
				.map((d) => d[xKey])
				.sort((a, b) => a - b)
				.filter((d, i) => d.getFullYear() % 5 === 0)

	if (add2021) {
		const year2021 = new Date('2021', 0, 1);
		xTicks.pop();
		xTicks.push(year2021)
	}
</script>

<LayerCake
	padding={{ top: 30, right: 10, bottom: 0, left: paddingLeft }}
	x={xKey}
	y={yKey}
	z={zKey}
	yDomain={[0, yMax]}
	zScale={scaleOrdinal()}
	zRange={seriesColors}
	flatData={flatten(groupedData, "values")}
	data={groupedData}
>
	<Svg>
		<AxisX
			gridlines={xGridlines}
			ticks={xTicks}
			formatTick={formatTickX}
			snapTicks={false}
			tickMarks={false}
			tickPosition={xTickPosition}
			baseline={true}
		/>
		<AxisY
			{yTicks}
			formatTick={formatTickY}
			gridlines={yGridlines}
			tickMarks={yTickMarks}
			dxTick={-10}
			dyTick={4}
			textAnchor="end"
		/>
		<MultiLine />
	</Svg>

	{#if showSeriesLabels}
		<Html>
			<Labels showLabels={true} {label} formatValue={formatValueLabel} class="chart_label" {labelPosition} />
		</Html>
	{/if}
</LayerCake>

<style>
	.label {
		border: 1px solid red;
	}
</style>
